<template lang="pug">
  .component.component-backoffice-reservation-rate(v-if="item", :class="item.status")
    .card(v-if="$is('listing')")
      .inner-content
        card3.add(:showAction="true", v-if="$is('listing')")
          dropdown(slot="actionBullets", :icon="'fa fa-ellipsis-v fa-2x action'", :position="'top'")
            // plan-reservation-rate-action-buttons(:item="item")
          .field(slot="n1")
            .field-value RR{{item.id}}
            .field-value {{item.name}}
          .field(slot="n2")
            template(v-if="item.time_rate")
              .field-value Time cost: {{currency}}{{withVat(item.time_rate.time_cost)}}/{{item.time_rate.time_cost_cycle}}min
              .field-value Driving time cost: {{currency}}{{withVat(item.time_rate.driving_time_cost)}}/{{item.time_rate.time_cost_cycle}}min
          .field(slot="n3")
            template(v-if="item.distance_rate")
              .field-value Distance cost
              .field-value {{currency}}{{withVat(item.distance_rate.distance_cost)}}/{{item.distance_rate.distance_cost_cycle}}{{configuration.locale.locale_distance_unit.value}}
          .field-url-detail(slot="actionPage")
            router-link(:to="{name:'configuration-rate', params:{id:item.id}}")
              i.fa.fa-angle-right.fa-3x.action


</template>

<script type="text/babel">
  import KeplerBackofficeSdk from "../../lib/kepler/backoffice";
  import MaggieHelper from "../../maggieHelper";
  import DatePicker from "components/structure/DatePicker"
  import Dropdown from 'components/structure/foundation/Dropdown'
  import Card9 from 'components/structure/Card9'
  import ReservationActionButtons from 'components/structure/ui/actions/ReservationActionButtons'
  import Driver from 'components/backoffice/Driver'
  import Vehicle from 'components/backoffice/Vehicle'
  import Tab7 from 'components/structure/Tab7'
  import Card4 from "../structure/Card4.vue";
  import Card5 from "../structure/Card5.vue";
  import ReservationFields from "../structure/ui/entity-fields/ReservationFields.vue";
  import Card8 from "../structure/Card8.vue";
  import Card7 from "../structure/Card7";
  import PlanReservationRateActionButtons from "../structure/ui/actions/PlanReservationRateActionButtons";
  import Card3 from "../structure/Card3";
  import {mapState} from 'vuex'

  export default {
    name: "BackofficeReservationRate",
    props: {
      item: Object,
      type: {
        type: String,
        default: ''
      }
    },
    components: {
      Card3,
      PlanReservationRateActionButtons,
      Card7,
      Card8,
      ReservationFields,
      Card5,
      Card4,
      DatePicker,
      Dropdown,
      Card9,
      ReservationActionButtons,
      Driver,
      Vehicle
    },
    data() {
      return {
        endTime: null
      }
    },
    mounted() {
      this.endTime = null
    },
    destroyed() {
    },
    methods: {
      withVat(price) {
        return price
      },
    },
    computed: {
      ...mapState({
        configuration: state => state.configuration,
      }),
      currency() {
        return this.configuration.commercial.commercial_currency.value
      },
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-reservation-rate
    .add
      padding: 0 20px
</style>



// WEBPACK FOOTER //
// ReservationRate.vue?58ac2da4